import {ActionTree} from 'vuex'
import {WidgetState} from "@/apps/StudentExchangeOverviewWidget/models/store-viewmodel"
import {ILabels} from "@/apps/StudentExchangeOverviewWidget/models/config-viewmodel"
import {IStudies} from "@/apps/StudentExchangeOverviewWidget/models/studies-viewmodel"
import services from "@/apps/StudentExchangeOverviewWidget/services"
import {AxiosResponse} from "axios"
import {ExchangeAction} from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import {IExchangeYear, IExchangeYears} from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel";

export default <ActionTree<WidgetState, any>>{
    loadStudentExchangeOverview(context) {
        context.commit('loading', true)
        let getters = context.getters
        
        services.studentExchange.getOverview(getters.getLanguage)
            .then((response: AxiosResponse) => {
                if(response.status === 204) {
                    context.commit('studies', [])
                } else {
                    context.commit('studies', response.data)
                    context.dispatch('setLastAcademicYearForFilter', response.data)
                }
            })
            .catch(() => {
                context.commit('loading', false)
                throw new Error('Something went wrong with retrieving your exchanges');
            })
            .finally(() => {
                context.commit('loading', false)
            })
    },
    exchangeAction(context, {action, type, programOfStudyId, academicYearId, exchangeId}: ExchangeAction)
    {
        let getters = context.getters;
        window.open(`/${getters.getLanguage}/overview/nonpartner/${programOfStudyId}/${academicYearId}/${exchangeId}`, '_self')
    },
    setLoading(context, payload: boolean): void {
        context.commit('loading', payload)
    },
    setLanguage(context, payload: boolean): void {
        context.commit('language', payload)
    },
    setLabels(context, payload: ILabels): void {
        context.commit('labels', payload)
    },
    setStudies(context, payload: IStudies): void {
        context.commit('studies', payload)
    },
    setLastAcademicYearForFilter(context, payload: IExchangeYears): void {
        if(!payload.length) return
        const lastAcademicYear = payload.reduce((previous: IExchangeYear, current: IExchangeYear) => {
            return (previous.academicYearId > current.academicYearId) ? previous : current
        })
        context.commit('selectedFilterYear', lastAcademicYear.academicYearId)
    },
    setSelectedFilterYear(context, payload: string): void {
        context.commit('selectedFilterYear', payload)
    },
    setSelectedFilterStudy(context, payload: string): void {
        context.commit('selectedFilterStudy', payload)
    },
    setModalOpen(context, payload: boolean): void {
        context.commit('isModalOpen', payload)
    },
    setOffset(context, payload: number): void {
        context.commit('offset', payload)
    }
}
